import { useFlags as useLaunchDarklyFlags } from 'launchdarkly-react-client-sdk';

function useFlagsF() {
  const flags = useLaunchDarklyFlags();

  return {
    disableAddMembers: flags.disableAddMembers ?? false,
    disableSmsChat: flags.disableSmsChat ?? false,
    enableCampaignManagerCampaigns:
      flags.enableCampaignManagerCampaigns ?? false,
    enableCTCandidateRoster: flags.enableCtCandidateRoster ?? false,
    enableInsurancesProtection: flags.enableInsurancesProtection ?? false,
    hideEcwDeprecatedPages: flags.hideEcwDeprecatedPages ?? false,
    rpmSettings: flags.rpmSettings ?? false,
    showAddInsuranceButton: flags.showAddInsuranceButton ?? false,
    showAddPatient: flags.showAddPatient ?? false,
    showBhi: flags.showBhi ?? false,
    showIcdDetectionPage: flags.showIcdDetectionPage ?? false,
    showOrderMedicalGuardianDevice:
      flags.showOrderMedicalGuardianDevice ?? false,
    showPhipPage: flags.showPhipPage ?? false,
    showReferralIngestionMapper: flags.showReferralIngestionMapper ?? false,
    showRosterFileHistory: flags.showRosterFileHistory ?? false,
    showRosterFileHistoryUpload: flags.showRosterFileHistoryUpload ?? false,
    showStyleguide: flags.showStyleguide ?? false,

    // SHUTDOWN FLAGS
    disableRpmOrders: true,
  };
}

export const useFlags = useFlagsF;
